import React from "react";
import { Route, Routes, useSearchParams } from "react-router-dom";
import { InnerHeader } from "../layout/InnerHeader/InnerHeader";
import { Layout } from "../layout";
import { SideNavbar } from "../layout/SideNavbar";

import { ToastContainer } from "react-bootstrap";
import {
  CustomerDashboard,
  LoginPage,
  OfficeAdminDashboard,
  PosAdminDashboard,
  SuperAdminDashboard,
  PrintInvoiceSummary,
} from "../modules";
import {
  DefaultRoute,
  OfficeAdminRoute,
  PosAdminRoute,
  SuperAdminRoute,
  CustomerRoute,
} from "./routerItems";
import { useAppSelector } from "../redux/Hooks/Hook";
import { DataRetentionProvider } from "../context/DataRetentionContext";

const Routing = () => {
  const role = useAppSelector(
    (state) => state.verifiedUser?.UserRole?.role?.name
  );

  let RouterItems: any[];

  switch (role) {
    case "SUPER_ADMIN":
      RouterItems = SuperAdminRoute;
      break;

    case "OFFICE_ADMIN":
      RouterItems = OfficeAdminRoute;
      break;

    case "POS_ADMIN":
      RouterItems = PosAdminRoute;
      break;

    case "END_USER":
      RouterItems = CustomerRoute;
      break;

    case null:
      RouterItems = DefaultRoute;
      break;

    default:
      RouterItems = DefaultRoute;
      break;
  }
  const otherUrl = () => {
    if (role === "POS_ADMIN") return <PosAdminDashboard />;
    else if (role === "OFFICE_ADMIN") return <OfficeAdminDashboard />;
    else if (role === "SUPER_ADMIN") return <SuperAdminDashboard />;
    else if (role === "END_USER") return <CustomerDashboard />;
    else return <LoginPage />;
  };
  const [searchParams] = useSearchParams();
  const typeOfPrint = searchParams.get("type");
  const idHash = searchParams.get("hash");
  const prefix = searchParams.get("prefix");
  const id = searchParams.get("id");


  return (
    <>
      {typeOfPrint != null && idHash != null ? (
        <Routes>
          <Route
            path="/printing"
            element={
              <PrintInvoiceSummary typeOfPrint={typeOfPrint} idHash={idHash} prefix={prefix} id={id} />
            }
          ></Route>
        </Routes>
      ) : (
        <>
          <Layout />
          <div className="wrapper d-flex align-items-stretch w-100">
            {role !== "POS_ADMIN" && <SideNavbar />}
            <div className="content">
              <InnerHeader role={role} />
              {role === "END_USER" && <DataRetentionProvider />}
              <Routes>
                {role ? (
                  RouterItems?.map((item) => {
                    return (
                      <Route
                        key={item.id}
                        path={item.path}
                        element={item.element}
                      />
                    );
                  })
                ) : (
                  <Route path="/" element={<LoginPage />} />
                )}

                {!role &&
                  DefaultRoute.map((elem) => {
                    return (
                      <Route
                        key={elem.id}
                        path={elem.path}
                        element={elem.element}
                      />
                    );
                  })}

                <Route path="*" element={otherUrl()} />
              </Routes>
            </div>
          </div>
        </>
      )}
      <ToastContainer />
    </>
  );
};

export { Routing };
